module.exports = __webpack_public_path__ + "img/cms_client_data_create.89b9ad79.png";